// Story 7.33 (ADO-2026): whether the shop is offered shelf plans on the active ordering entry.
//
// The server decides it (SL1.0's rule: the shop's fascia has a plan with a product in the entry's
// range, the environment is not WOW, Elite, LSN or CorribRetail, and the account is not
// Foodservice or Licence Trade), so the web never guesses: until the answer arrives, and when the
// read fails, the Planogram entry is not shown. Another entry is asked afresh.

import { useEffect, useState } from 'react';
import { fetchPlanogramFilters } from '../api/planogram.client';
import { useCatalogueEntryKey } from '../ordering/catalogueEntry';

/** The plan pages' route: the Format and Category pickers and the plan grid. */
export const PLANOGRAMS_ROUTE = '/planograms';

/** The Planogram entry's target, for the header and the phone's toolbar chip. */
export const PLANOGRAM_NAV = Object.freeze({ to: PLANOGRAMS_ROUTE });

export function usePlanogramAvailability(): boolean {
  const entry = useCatalogueEntryKey();
  const [answer, setAnswer] = useState<{ entry: string; available: boolean } | null>(null);

  useEffect(() => {
    if (entry === null) return undefined;
    let cancelled = false;
    fetchPlanogramFilters(entry, null).then(
      (filters) => {
        if (!cancelled) setAnswer({ entry, available: filters.available });
      },
      () => {
        if (!cancelled) setAnswer({ entry, available: false });
      },
    );
    return () => {
      cancelled = true;
    };
  }, [entry]);

  return answer !== null && answer.entry === entry && answer.available;
}

/** A plan page's query string: the chosen Format and Category, only what is set. */
export function planogramSearch(format: string, category: string): string {
  const params = new URLSearchParams();
  if (format !== '') params.set('format', format);
  if (category !== '') params.set('category', category);
  const search = params.toString();
  return search === '' ? '' : `?${search}`;
}
